import * as React from 'react';

import CoursesV1 from 'bundles/naptimejs/resources/courses.v1';
import ConsumerEnrollButtonNotConfigurable from 'bundles/unified-description-page-common/components/enroll/consumer/ConsumerEnrollButtonNotConfigurable';
import type { ConsumerSpecializationPageFieldsFragment } from 'bundles/unified-description-page-common/queries/bff/__generated__/ConsumerSpecializationPageQuery';

const ConsumerSpecializationEnrollButtonNotConfigurable = ({
  pageData,
  size,
  onlyShowButton,
}: {
  pageData: ConsumerSpecializationPageFieldsFragment;
  size?: 'small' | 'large';
  onlyShowButton?: boolean;
}) => {
  if (!pageData) {
    return null;
  }

  return (
    <ConsumerEnrollButtonNotConfigurable
      courseCount={pageData.courses?.length}
      s12nId={pageData.id}
      partnerIds={pageData?.partners?.map(({ id }) => id)}
      name={pageData.name}
      slug={pageData.slug}
      isSpecialization
      onStickyHeader={size === 'small'}
      onlyShowButton={onlyShowButton}
      courseId={pageData.courses?.[0]?.id}
      course={
        new CoursesV1({
          slug: pageData.courses?.[0]?.slug,
          id: pageData.courses?.[0]?.id,
          name: pageData.courses?.[0]?.name,
        })
      }
    />
  );
};

export default ConsumerSpecializationEnrollButtonNotConfigurable;
